import { supabase } from "../supabase/client";
import { Database } from "../database.types";

export type AIAgent = Database["public"]["Tables"]["ai_agents"]["Row"];

export async function getUserActiveAgents(userId: string): Promise<AIAgent[]> {
  // Fetching active agents for user

  try {
    // Get user's active subscription
    const { data: subscriptions, error: subscriptionError } = await supabase
      .from("subscriptions")
      .select("plan_id")
      .eq("user_id", userId)
      .eq("status", "active");

    if (subscriptionError) {
      console.error("Error fetching subscription:", subscriptionError);
      throw new Error(
        `Error fetching subscription: ${subscriptionError.message}`
      );
    }

    // If no active subscription, return empty array
    if (!subscriptions || subscriptions.length === 0) {
      // No active subscription found for user
      return [];
    }

    const subscription = subscriptions[0]; // Take the first active subscription
    // Found active subscription

    // Get plan's AI agents using plan_id
    const { data: planAgents, error: planAgentsError } = await supabase
      .from("plan_agents")
      .select("agent_id")
      .eq("plan_id", subscription.plan_id);

    if (planAgentsError) {
      console.error("Error fetching plan agents:", planAgentsError);
      throw new Error(`Error fetching plan agents: ${planAgentsError.message}`);
    }

    if (!planAgents || planAgents.length === 0) {
      // No agents found for plan
      return [];
    }
    //legal-chatbot, document-generator,consumer-assistant
    // Get agent details
    const agentIds = planAgents.map((pa) => pa.agent_id);
    const { data: agents, error: agentsError } = await supabase
      .from("ai_agents")
      .select("*")
      .in("id", agentIds)
      .eq("is_visible", true);

    if (agentsError) {
      console.error("Error fetching agents:", agentsError);
      throw new Error(`Error fetching agents: ${agentsError.message}`);
    }

    return agents || [];
  } catch (error) {
    console.error("Error in getUserActiveAgents:", error);
    throw error;
  }
}

export async function getAgentById(agentId: string): Promise<AIAgent | null> {
  const { data: agent, error } = await supabase
    .from("ai_agents")
    .select("*")
    .eq("id", agentId)
    .eq("is_visible", true)
    .single();

  if (error) {
    console.error("Error fetching agent:", error);
    return null;
  }

  return agent;
}
